import { VMenu } from "vuetify/lib";

/**
 * header 專用的 v-menu（小芋頭服務、通知、頭像、子站導覽的下拉）。
 *
 * 平台站的 header 包在 position: sticky 的 .fixed-bar 裡（sass/variables.scss）。
 * Vuetify 2 的 v-menu 打開時會往上找 activator 的祖先，只認得 position: fixed：
 *   - 認得 → 選單用 fixed 定位，跟 header 一起留在畫面上
 *   - 認不得 → 選單用 absolute 定位在文件上，使用者一捲動，選單就跟著頁面
 *     往上跑，header 卻黏在原地，兩者分家
 * sticky 屬於後者，所以這裡把 sticky 也當成 fixed。
 *
 * 只用在 header，不要拿去全站替換 v-menu：sticky 元素在「還沒黏住」之前是
 * 跟著頁面捲的，一般的 sticky 區塊不能當成 fixed。header 永遠在頁面最上方，
 * 從一開始就是黏住的狀態，才可以這樣假設。
 *
 * 覆寫的是 vuetify/lib/mixins/menuable 的 checkActivatorFixed，
 * 除了多認 sticky，其餘與原版逐行相同。
 */
export default VMenu.extend({
  name: "header-menu",
  methods: {
    checkActivatorFixed() {
      if (this.attach !== false) return;
      let el = this.getActivator();

      while (el) {
        const position = window.getComputedStyle(el).position;
        if (position === "fixed" || position === "sticky") {
          this.activatorFixed = true;
          return;
        }

        el = el.offsetParent;
      }

      this.activatorFixed = false;
    },
  },
});
